<template lang="pug">
  v-container
    v-dialog( persistent  :value='validatorRestrictions'  max-width='500px')
      div(style ='position:relative; height: 100%;')
        validate-restrictions(:data="dataValidator" @close="validatorRestrictions=false")
    v-dialog( persistent  :value='validatorRestrictionsStatus'  max-width='500px')
      div(style ='position:relative; height: 100%;')
        validate-restrictions(:data="dataValidatorStatus" @close="validatorRestrictionsStatus=false")
    v-snackbar(v-model='show' color='red' center top :timeout="4000")
      | {{message}}
      v-btn(dark='' text='' @click='show = false')
        | Close
    v-card
      v-card-title.dialog-card-title
        p Crear Colaborador
        v-icon(color="white" aria-label="Close" @click="$emit('close')") mdi-close
      v-card-text.body-1.text-center.mt-2
        v-row
          v-col(cols="12" md="12")
              v-layout
                formStepper(v-if="!fromStore" :model ='model', :field='field' :onSave='createItem' :context='currentContext' @cancel="cancel")
                RestaurentStepper(v-else :model='modelRest' :onSave='createItem' @cancel="cancel")
</template>
<script>
  import Stepper from '../../components/custom/steppers/UserStepper.vue'
  import axios from 'axios'
  import * as vars from '@/vars.json'
  let vm = null
  export default {
    components: {
      formStepper: Stepper,
      ValidateRestrictions: () => import('@/views/pages/components/ValidateRestrictions'),
      RestaurentStepper: () => import('@/components/custom/steppers/RestaurantStepper'),
    },
    props: {
      fromStore: {
        type: Boolean,
        default: () => false,
      },
    },
    data: () => ({
      validatorRestrictions: false,
      validatorRestrictionsStatus: false,
      collaboratorsRestriction: null,
      model: {
        displayName: '',
        email: '',
        password: '',
        role: '',
        shops: [],
        permissions: {
          sales: false,
          orders: false,
          purchases: false,
          transfers: false,
          expenses: false,
          returns: false,
          'add-inventory': false,
          logs: false,
          inventory: false,
          summary: false,
        },
      },
      field: {
        types: [{ name: 'Punto de venta', value: 'pos' }, { name: 'Bodega', value: 'warehouse' }],
      },
      currentContext: 'posts',
      message: '',
      show: false,
      // - Resturant
      modelRest: {
        email: '',
        password: '',
        role: '',
        shops: [],
      },
    }),
    computed: {
      dataValidator () {
        return {
          title: this.$t('shop.createModule.titleValiadtorCollaborator'),
          message: this.$t('shop.createModule.messageValidatorCollaborator'),
        }
      },
      dataValidatorStatus () {
        return {
          title: this.$t('shop.createModule.titleValiadtorShopStatus'),
          message: this.$t('shop.createModule.messageValidatorShopStatus'),
        }
      },
      totalCollaborators () {
        return this.$store.getters['admins/getItems'].length
      },
      icon () {
        const category = this.model.category
        let categoryIcon = null
        switch (category) {
          case 'nation':
            categoryIcon = 'mdi-alpha-n-box'
            break
          case 'economy':
            categoryIcon = 'mdi-alpha-e-box'
            break
          case 'life':
            categoryIcon = 'mdi-alpha-v-box'
            break
          case 'international':
            categoryIcon = 'mdi-alpha-i-box'
            break
          case 'trending':
            categoryIcon = 'mdi-alpha-v'
            break
          case 'sports':
            categoryIcon = 'mdi-alpha-d-box'
            break
          case 'entertainment':
            categoryIcon = 'mdi-alpha-e'
            break
          case 'technology':
            categoryIcon = 'mdi-alpha-c-box'
            break
        }
        return categoryIcon
      },
      isLoading () {
        // console.log(this.$store.getters['admins/getLoading'])
        return this.$store.getters['admins/getLoading']
      },
      profile () {
        return this.$store.getters['users/getProfile']
      },
    },
    created () {
      vm = this
      // const database = firebase.database();
      // const storage = firebase.storage();
    },
    mounted () {
      const vm = this
      this.$store.dispatch('users/getUidUser').then(res => {
        this.$store.dispatch('users/getRestrictions').then(res => {
          // console.log(res)
          if (res) {
            vm.collaboratorsRestriction = res.restrictions.collaborators
            vm.status = res.status.val
            if (vm.status !== 'active') {
              vm.validatorRestrictionsStatus = true
              vm.banCreateColaborator = true
              return
            }
            if (vm.collaboratorsRestriction === null) {
              vm.validatorRestrictions = true
              vm.banCreateColaborator = true
              return
            }
            if (vm.collaboratorsRestriction <= vm.totalCollaborators) {
              vm.validatorRestrictions = true
              vm.banCreateColaborator = true
            }
          } else {
            vm.validatorRestrictionsStatus = true
            vm.banCreateColaborator = true
          }
        })
      })
    },
    methods: {

      createItem: function () {
        const vm = this
        vm.isLoading = true
        const itemData = vm.fromStore ? vm.modelRest : vm.model
        itemData.adminUid = vm.$store.state.users.user.uid
        itemData.country = vm.profile && vm.profile.direction && vm.profile.direction.country ? vm.profile.direction.country : 'CO'
        axios.post(vars.url + '/createCollaborator', itemData).then(res => {
          vm.$store.commit('admins/SET_LOADING', false)
          vm.onSuccess()
          if (vm.fromStore) return
          const data = {
            shops: [],
            collaborators: vm.$store.getters['admins/getItems'],
          }
          vm.$store.dispatch('payment/getSubscriptionData', data)
          vm.isLoading = false
        }).catch(e => {
          vm.$store.commit('admins/SET_LOADING', false)
          vm.isLoading = false
          if (e.response) {
            vm.message = e.response.data.error.message
            vm.show = true
          }
        })
      },
      refresh () {
        this.model = {
          uid: null,
          name: null,
          // picpictures:{
          //     imageInput1: '',
          // }
        }
      },
      onSuccess () {
        this.refresh()
        this.$emit('refresh')
        this.$emit('close')
      },
      cancel () {
        this.refresh()
        this.$emit('close')
      },
      setImage (image) {
        vm.model.imagen = image
        // // console.log(vm.model.imagen);
      },
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .ql-video {
        max-width: 100%;

    }
    img{
        max-width: 100%;
        height:auto;
    }
</style>
